import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/home.vue'),
      meta: {
        pid: 1,
        title: '時の広告社',
        description: '茨城県水戸市にあるデザイン制作会社「時の広告社」では、クリエイティブな発想とさまざまなメディアに対応する幅広い表現力で、心を動かすコミュニケーションのカタチを追求しています。'
      }
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/about.vue'),
      meta: {
        pid: 2,
        title: '会社の哲学',
        description: '時の広告社の哲学。茨城県水戸市のデザイン制作会社「時の広告社」が大切にする、ものづくりへの考え方とクリエイティブへのこだわりについて。'
      }
    },
    {
      path: '/policy',
      name: 'policy',
      component: () => import('./views/policy.vue'),
      meta: {
        pid: 3,
        title: '制作理念',
        description: '時の広告社の制作理念。クライアントの想いをカタチにするデザイン制作会社として、品質・納期・コミュニケーションに徹底してこだわります。'
      }
    },
    {
      path: '/client-work',
      name: 'client-work',
      component: () => import('./views/client-work.vue'),
      meta: {
        pid: 4,
        title: '制作事例',
        description: '茨城県水戸市のデザイン制作会社「時の広告社」の制作実績一覧。WEBサイト、ロゴ、印刷物など、多彩なメディアに対応した事例をご紹介。'
      }
    },
    {
      path: '/client-work-demo',
      name: 'client-work-demo',
      component: () => import('./views/client-work-demo/index.vue'),
      meta: {
        pid: 98,
        title: '制作事例',
        description: '「時の広告社」の制作事例を詳しくご紹介。デザインの意図や制作プロセスまでご覧いただけます。'
      }
    },
    {
      path: '/client-work-demo/:id',
      name: 'product',
      component: () => import('./views/client-work-demo/product.vue')
    },
    {
      path: '/project',
      name: 'project',
      component: () => import('./views/project.vue'),
      meta: {
        pid: 5,
        title: 'プロジェクト',
        description: '自社メディアの企画・運営を通して地域資源の活性化に取り組んでいます。'
      }
    },
    {
      path: '/company',
      name: 'company',
      component: () => import('./views/company.vue'),
      meta: {
        pid: 6,
        title: '会社概要',
        description: '茨城県水戸市のデザイン制作会社「時の広告社」の会社概要。所在地、代表者、事業内容、沿革をご案内。'
      }
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: () => import('./views/privacy-policy.vue'),
      meta: {
        pid: 7,
        title: 'プライバシーポリシー',
        description: '時の広告社のプライバシーポリシー。お客様の個人情報の取り扱いに関する方針を掲載しています。'
      }
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('./views/contact.vue'),
      meta: {
        pid: 8,
        title: 'お問い合わせ',
        description: 'デザイン制作会社「時の広告社」へのお問い合わせフォーム。WEBサイト・ロゴ・印刷物などの制作依頼、お見積もり依頼をお待ちしています。'
      }
    },
    {
      path: '/thanks',
      name: 'thanks',
      component: () => import('./views/thanks.vue'),
      meta: {
        pid: 9,
        title: '送信完了',
        description: 'お問い合わせありがとうございます。時の広告社より順次ご連絡いたします。'
      }
    },
    {
      path: '/access',
      name: 'access',
      component: () => import('./views/access.vue'),
      meta: {
        pid: 10,
        title: '本社へのアクセス',
        description: '茨城県水戸市のデザイン制作会社「時の広告社」本社へのアクセス情報。所在地、地図、公共交通機関でのアクセス方法をご案内。'
      }
    },
    {
      path: '/link',
      name: 'link',
      component: () => import('./views/link.vue'),
      meta: {
        pid: 11,
        title: 'リンク',
        description: '時の広告社の関連リンク集。'
      }
    },
    {
      path: '/recruit',
      name: 'recruit',
      component: () => import('./views/recruit.vue'),
      meta: {
        pid: 12,
        title: '採用情報',
        description: '茨城県水戸市のデザイン制作会社「時の広告社」の採用情報。デザイナー・クリエイティブ職の募集要項をご案内。'
      }
    },
    {
      path: '*',
      name: '404',
      component: () => import('./views/404.vue'),
      meta: {
        pid: 13,
        title: 'ページがありません',
        description: 'お探しのページは見つかりませんでした。時の広告社｜茨城県水戸市のデザイン制作会社'
      }
    },
    { path: '/index.html', redirect: '/' },
    { path: '/about.html', redirect: '/about' },
    { path: '/contact.html', redirect: '/contact' },
    { path: '/env.html', redirect: '/company' },
    { path: '/link.html', redirect: '/link' },
    { path: '/map.html', redirect: '/access' },
    { path: '/policy.html', redirect: '/privacy-policy' },
    { path: '/works.html', redirect: '/clientwork' },
    { path: '/yutari.html', redirect: '/project' },
    { path: '/yutariya.html', redirect: '/project' },
    { path: '/career.html', redirect: '/recruit' },
    { path: '/guid.html', redirect: '*' },
    { path: '/phil.html', redirect: '*' },
    { path: '/t_box_base.html', redirect: '*' },
    { path: '/t_box_full.html', redirect: '*' },
    { path: '/t_box.html', redirect: '*' }
  ],
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve) => {
      if (savedPosition) {
        return savedPosition
      } else {
        setTimeout(() => resolve({ x: 0, y: 0 }), 700)
      }
    })
  }
})

router.beforeEach((to, from, next) => {
  document.title = (to.name !== 'home' ? `${to.meta.title}｜` : '') + '時の広告社｜茨城県水戸市のデザイン制作会社'
  document.querySelector('meta[name="description"]')!.setAttribute('content', to.meta.description)
  document.querySelector('meta[property="og:url"]')!.setAttribute('content', `https://tokino.co.jp${to.fullPath}`)
  document.querySelector('meta[property="og:title"]')!.setAttribute('content', document.title)
  document.querySelector('meta[property="og:description"]')!.setAttribute('content', to.meta.description)
  next()
})

export default router